import { Language } from '../enums';
import { AppRoutePath, getTranslatedRoutePath } from '../route-translation';

export function isHotelDetailsRoute(path: string, language: Language): boolean {
	const segments = path.split('/').filter((segment) => segment.length > 0);
	const tourSegment = getTranslatedRoutePath(AppRoutePath.Tours, language);
	const hotelSegment = getTranslatedRoutePath(AppRoutePath.Hotels, language);
	// Check if it matches pattern: sr/tour/{state}/{region}/{town}/{hotelName}
	const typeSegment = segments[1];
	return segments.length === 6 && (typeSegment === tourSegment || typeSegment === hotelSegment);
}
